import { Channel } from '../../domain';
import { ExtendedMessageType } from '../types';

const byMessageChannelId =
  (channelIds: Set<Channel['id']>) =>
  ({ messageChannelId }: ExtendedMessageType) =>
    channelIds.has(messageChannelId);

export const filterByMessageChannelIds = (
  messageTypes: ExtendedMessageType[],
  messageTypeIds: Set<Channel['id']>,
) => messageTypes.filter(byMessageChannelId(messageTypeIds));
